export default "__VITE_ASSET__549f4570__"